import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { provideComponentStore } from '@ngrx/component-store';
import { paths } from '@platform/paths';
import { PortfolioCardComponent } from '@platform/portfolio/components/portfolio-card/portfolio-card.component';
import { SmartSearchCardComponent } from '@platform/portfolio/components/smart-search-card/smart-search-card.component';
import { PortfolioCardDetailStore } from '@platform/portfolio/pages/portfolio-card-detail/portfolio-card-detail.store';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cp-portfolio-card-detail',
  imports: [PortfolioCardComponent, AsyncPipe, SmartSearchCardComponent, IconComponent, ButtonDirective, RouterLink],
  templateUrl: './portfolio-card-detail.component.html',
  styleUrl: './portfolio-card-detail.component.scss',
  providers: [provideComponentStore(PortfolioCardDetailStore)],
})
export class PortfolioCardDetailComponent {
  protected readonly componentStore = inject(PortfolioCardDetailStore);

  protected readonly propertyPortfolioItem$ = this.componentStore.propertyPortfolioItem$;
  protected readonly smartSearchItem$ = this.componentStore.smartSearchItem$;
  protected readonly paths = paths;

  protected backButtonHidden = false;

  showAllCards(showAll: boolean): void {
    this.backButtonHidden = showAll;
  }
}
